import {postRequest} from '@/http/http.js'

const LOGIN_URL = '/api/auth/login'
const LOGOUT_URL = '/api/auth/logout'
const REGISTER_URL = '/api/auth/register'
const USER_AUTH_URL = '/api/auth/userAuth'
const SEND_SMS_CAPTCHA_URL = '/api/auth/sendSMSCaptcha'

const QUERY_PUBLIC_WELFARE_PROJECT_URL = '/api/publicWelfareProject/query'
const QUERY_PUBLIC_WELFARE_PROJECT_ENTITY_URL = '/api/publicWelfareProject/queryEntity'
const QUERY_PUBLIC_WELFARE_PROJECT_LIST_URL = '/api/publicWelfareProject/queryList'
const QUERY_PUBLIC_WELFARE_PROJECT_PAGE_URL = '/api/publicWelfareProject/queryPage'
const QUERY_PUBLIC_WELFARE_PROJECT_PAGE_BY_ANCESTOR_ID_URL = '/api/publicWelfareProject/queryPublicWelfareProjectPageByAncestorId'
const QUERY_STATIC_RESOURCES_LIST_URL = '/api/staticResources/queryList'
const QUERY_STATIC_RESOURCES_TREE_URL = '/api/staticResources/queryTree'
const QUERY_STATIC_RESOURCES_PAGE_URL = '/api/staticResources/queryPage'
const QUERY_CAROUSEL_PICTURE_FILE_URL = '/api/welfareProject/queryCarouselPictureFile'
const QUERY_WELFARE_DONATION_URL = '/api/welfareProject/queryWelfareDonation'
const DOWNLOAD_FILE_URL = '/api/file/downloadFile'

const QUERYCURRENTUSERBYUSERID_URL = '/api/user/query'
const EDITUSER_URL = '/api/user/edit'
const QUERY_CURRENT_USER_URL = '/api/user/queryCurrentUser'
const QUERY_OFFICIAL_MENU_TREE_URL = '/api/staticResources/queryOfficialMenuTree'

const MBERSHIPADD_URL = '/api/membershipfees/add'
const QUERYMEMBERSHIP_URL = '/api/membershipfees/queryPage'
const QUERYMEMBERSHIPJIAMI_URL = '/api/membershipfees/queryPageJiami'
const CREATEQRCODEURLC_URL = '/api/member/createQRcodeUrl'
const QUERYPAYSTATUS_URL = '/api/member/queryPayStatus'
const EDITUSERPW_URL = '/api/user/editPw' // 能修改密码

const QUERYLOGINSTATUS_URL = '/api/wechart/queryLoginStatus'
const CHECKPHONE_URL = '/api/wechart/checkPhone'
const QUERY_USERINFO_BYSTATE_URL = '/api/wechart/queryUserInfoByState'
const MBERSHIPADDSJ_URL = '/api/membershipfees/addSj'

const EDITUSER_Sj_URL = '/api/user/editSj'

const PAY_USER_HUIFEI_URL = '/api/user/payUserHuifei'

const HOME_DATA_URL = '/api/home/data'
const LEAVEMESSAGEADD_URL = '/api/publicWelfareProject/leaveMessageAdd'
const QUERYALLLEAVEMESSAGE_URL = '/api/publicWelfareProject/queryAllLeaveMessage'

export async function userAuthRequest() {
    return (
        await postRequest(USER_AUTH_URL)
    ).data
}

export async function queryPublicWelfareProject(publicWelfareProjectId) {
    if (!publicWelfareProjectId) {
        throw new Error()
    }

    return (
        await postRequest(QUERY_PUBLIC_WELFARE_PROJECT_URL, publicWelfareProjectId)
    ).data
}

export async function queryPublicWelfareProjectEntity(data) {
    return (
        await postRequest(QUERY_PUBLIC_WELFARE_PROJECT_ENTITY_URL, data)
    ).data
}

export async function queryPublicWelfareProjectList(data) {
    return (
        await postRequest(QUERY_PUBLIC_WELFARE_PROJECT_LIST_URL, data)
    ).data
}

export async function queryPublicWelfareProjectPage(data) {
    return (
        await postRequest(QUERY_PUBLIC_WELFARE_PROJECT_PAGE_URL, data)
    ).data
}

export async function queryPublicWelfareProjectPageByAncestorId(data) {
    return (
        await postRequest(QUERY_PUBLIC_WELFARE_PROJECT_PAGE_BY_ANCESTOR_ID_URL, data)
    ).data
}

export async function queryStaticResourcesList(data) {
    return (
        await postRequest(QUERY_STATIC_RESOURCES_LIST_URL, data)
    ).data
}

export async function queryStaticResourcesPage(data) {
    return (
        await postRequest(QUERY_STATIC_RESOURCES_PAGE_URL, data)
    ).data
}

export async function queryStaticResourcesTree(data) {
    return (
        await postRequest(QUERY_STATIC_RESOURCES_TREE_URL, data)
    ).data
}

export async function queryCarouselPictureFileRequest() {
    return (
        await postRequest(QUERY_CAROUSEL_PICTURE_FILE_URL)
    ).data
}

export async function queryWelfareDonationRequest() {
    return (
        await postRequest(QUERY_WELFARE_DONATION_URL)
    ).data
}

export async function downloadRequest(url, isFull = false) {
    const requestUrl = isFull ? '/' + url : `${DOWNLOAD_FILE_URL}?url=${url}`
    return (
        await postRequest(requestUrl)
    ).data
}

export async function loginRequest(data) {
    return (
        await postRequest(LOGIN_URL, {
            username: data.username,
            password: data.password,
            cellphone: data.cellphone,
            userType: data.userType,
        })
    ).data
}

export async function logoutRequest() {
    return (await postRequest(LOGOUT_URL)).data
}

export async function register(data) {
    return (
        await postRequest(REGISTER_URL, data)
    ).data
}

export async function queryCurrentUserByUserid(data) {
    return (
        await postRequest(QUERYCURRENTUSERBYUSERID_URL, data)
    ).data
}

export async function queryCurrentUser() {
    return (
        await postRequest(QUERY_CURRENT_USER_URL)
    ).data
}

export async function editUser(data) {
    return (
        await postRequest(EDITUSER_URL, data)
    ).data
}

export async function sendSMSCaptchaRequest(cellphone) {
    return (await postRequest(SEND_SMS_CAPTCHA_URL, cellphone)).data
}

export async function queryMembership(data) {
    return (await postRequest(QUERYMEMBERSHIP_URL, data)).data
}

export async function queryMembershipJiami(data) {
    return (await postRequest(QUERYMEMBERSHIPJIAMI_URL, data)).data
}

export async function createQRcodeUrlC(data) {
    return (await postRequest(CREATEQRCODEURLC_URL, data)).data
}

export async function queryPayStatus(data) {
    return (await postRequest(QUERYPAYSTATUS_URL, data)).data
}

export async function queryOfficialMenuTree(data) {
    return (await postRequest(QUERY_OFFICIAL_MENU_TREE_URL, data)).data
}

export async function editUserPw(data) {
    return (
        await postRequest(EDITUSERPW_URL, data)
    ).data
}

export class createCertificate {
}

export async function queryCurrentUserRequest() {
    return (await postRequest(QUERY_CURRENT_USER_URL)).data
}

export async function membershipfeesAdd(data) {
    return (
        await postRequest(MBERSHIPADD_URL, data)
    ).data
}

export async function queryLoginStatus(data) {
    return (
        await postRequest(QUERYLOGINSTATUS_URL, data)
    ).data
}

export async function checkPhone(data) {
    return (
        await postRequest(CHECKPHONE_URL, data)
    ).data
}

export async function membershipfeesAddSj(data) {
    return (
        await postRequest(MBERSHIPADDSJ_URL, data)
    ).data
}

export async function editUserSj(data) {
    return (
        await postRequest(EDITUSER_Sj_URL, data)
    ).data
}

export async function queryHomeData() {
    return (
        await postRequest(HOME_DATA_URL)
    ).data
}

export async function payUserHuifei(data) {
    return (
        await postRequest(PAY_USER_HUIFEI_URL, data)
    ).data
}

export async function queryUserInfoByState(data) {
    return (
        await postRequest(QUERY_USERINFO_BYSTATE_URL, data)
    ).data
}

export async function leaveMessageAdd(data) {
    return (
        await postRequest(LEAVEMESSAGEADD_URL, data)
    ).data
}

export async function queryAllLeaveMessage(data) {
    return (
        await postRequest(QUERYALLLEAVEMESSAGE_URL, data)
    ).data
}
